// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AdminCandidates_page__inl85 { max-width: 1600px; }
.AdminCandidates_pageHeader__amqEM { display: flex; align-items: flex-start; justify-content: space-between; margin-bottom: 1.25rem; gap: 1rem; flex-wrap: wrap; }
.AdminCandidates_pageTitle__ZHhk\\+ { font-size: 1.4rem; color: var(--black); margin-bottom: 0.2rem; }
.AdminCandidates_pageSub__gOZtf { font-size: 0.8rem; color: var(--gray-500); }
.AdminCandidates_actionBtn__oM\\+zp { padding: 0.55rem 1rem; background: var(--green); color: white; border: none; border-radius: var(--radius); font-size: 0.82rem; font-weight: 500; transition: background 0.15s; }
.AdminCandidates_actionBtn__oM\\+zp:hover { background: #155a30; }

.AdminCandidates_filterBtn__Sxc2x { padding: 0.4rem 0.85rem; background: transparent; border: 1px solid var(--border); border-radius: 100px; font-size: 0.78rem; color: var(--gray-700); transition: all 0.12s; }
.AdminCandidates_filterBtn__Sxc2x:hover { background: var(--gray-50); }
.AdminCandidates_filterBtn__Sxc2x.AdminCandidates_active__tzc09 { background: var(--green); color: white; border-color: var(--green); }
.AdminCandidates_filterCount__y0Y-l { opacity: 0.7; font-size: 0.7rem; color: #dc2626; }
.AdminCandidates_filterBtn__Sxc2x.AdminCandidates_active__tzc09 .AdminCandidates_filterCount__y0Y-l { color: white; }

.AdminCandidates_searchBar__\\+i\\+u6 { margin-bottom: 1.25rem; display: flex; align-items: center; gap: 1rem; flex-wrap: wrap; }
.AdminCandidates_filtersInline__RllPR { display: flex; gap: 0.5rem; flex-wrap: wrap; }
.AdminCandidates_searchInput__iBuhh { padding: 0.6rem 1rem; border: 1px solid var(--border); border-radius: var(--radius); font-size: 0.82rem; color: var(--gray-900); transition: border-color 0.15s; flex: 1 1; min-width: 200px; }
.AdminCandidates_searchInput__iBuhh:focus { outline: none; border-color: var(--green); }
.AdminCandidates_searchInput__iBuhh::placeholder { color: var(--gray-400); }

.AdminCandidates_credBox__mB5OF {
  border: 1px solid rgba(26,92,56,0.25);
  border-radius: var(--radius-lg);
  background: var(--green-light);
  margin-bottom: 1.25rem;
  overflow: hidden;
}
.AdminCandidates_credHeader__MNQ9g { display: flex; align-items: center; justify-content: space-between; padding: 0.75rem 1rem; border-bottom: 1px solid rgba(26,92,56,0.15); }
.AdminCandidates_credTitle__K6L-0 { font-size: 0.82rem; font-weight: 600; color: var(--green); }
.AdminCandidates_credClose__Pzmha { background: none; border: none; color: var(--green); font-size: 1.1rem; line-height: 1; }
.AdminCandidates_credBody__Vc-nG { padding: 1rem; }
.AdminCandidates_credText__vwEPw { font-size: 0.82rem; color: var(--gray-700); margin-bottom: 0.85rem; }
.AdminCandidates_credDetails__nHVCX { display: flex; flex-direction: column; gap: 0.5rem; margin-bottom: 0.85rem; }
.AdminCandidates_credRow__u5agf { display: flex; align-items: center; gap: 1rem; }
.AdminCandidates_credKey__s-Aid { font-size: 0.75rem; color: var(--gray-500); width: 200px; flex-shrink: 0; }
.AdminCandidates_credValue__2Xvmq { font-size: 0.82rem; color: var(--gray-900); }
.AdminCandidates_credPassword__\\+\\+f2F { font-size: 1.1rem; font-weight: 700; color: var(--green); letter-spacing: 0.1em; font-family: 'Courier New', monospace; background: white; padding: 4px 12px; border-radius: 6px; border: 1px solid rgba(26,92,56,0.2); }
.AdminCandidates_credWarning__-id\\+B { font-size: 0.75rem; color: #d35400; }

.AdminCandidates_successBox__ywIed {
  border: 1px solid rgba(26,92,56,0.25);
  border-radius: var(--radius-lg);
  background: var(--green-light);
  margin-bottom: 1.25rem;
  padding: 0.85rem 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.65rem;
  animation: AdminCandidates_slideDown__uaJDy 0.3s ease;
}

.AdminCandidates_successContent__LUgta {
  display: flex;
  align-items: center;
  gap: 0.65rem;
}

.AdminCandidates_successIcon__I-c4V {
  font-size: 1rem;
  color: var(--green);
  font-weight: bold;
}

.AdminCandidates_successText__F25fk {
  font-size: 0.82rem;
  font-weight: 600;
  color: var(--green);
}

@keyframes AdminCandidates_slideDown__uaJDy {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Credential Popup Card */
.AdminCandidates_credPopupOverlay__BdvUq {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
}

.AdminCandidates_credPopupCard__5vKhl {
  background: white;
  border-radius: 12px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
  max-width: 320px;
  width: 100%;
  position: relative;
  animation: AdminCandidates_popUp__0ZoXo 0.3s ease;
}

@keyframes AdminCandidates_popUp__0ZoXo {
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

.AdminCandidates_credPopupClose__9lv2x {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  background: none;
  border: none;
  font-size: 1.5rem;
  color: var(--gray-400);
  cursor: pointer;
  transition: color 0.2s;
}

.AdminCandidates_credPopupClose__9lv2x:hover {
  color: var(--gray-600);
}

.AdminCandidates_credPopupContent__1Ou2- {
  padding: 1.25rem 1rem;
  text-align: center;
}

.AdminCandidates_credPopupIcon__NmVzb {
  font-size: 1.8rem;
  margin-bottom: 0.3rem;
  display: block;
}

.AdminCandidates_credPopupTitle__2d3sO {
  font-size: 0.95rem;
  font-weight: 600;
  color: var(--black);
  margin-bottom: 0.15rem;
}

.AdminCandidates_credPopupSubtitle__lTJjW {
  font-size: 0.8rem;
  color: var(--gray-500);
  margin-bottom: 0.85rem;
}

.AdminCandidates_credPopupItem__CU7ah {
  text-align: left;
  margin-bottom: 0.7rem;
  padding: 0.6rem;
  background: var(--gray-50);
  border-radius: 6px;
}

.AdminCandidates_credPopupLabel__OSpSI {
  display: block;
  font-size: 0.7rem;
  font-weight: 600;
  color: var(--gray-500);
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-bottom: 0.35rem;
}

.AdminCandidates_credPopupValue__-S-xc {
  display: block;
  font-size: 0.8rem;
  color: var(--gray-900);
  word-break: break-all;
}

.AdminCandidates_credPopupCopyRow__hfYLl {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  justify-content: space-between;
}

.AdminCandidates_credPopupCode__ycfE8 {
  display: block;
  font-size: 1.1rem;
  font-weight: 700;
  color: var(--green);
  letter-spacing: 0.15em;
  font-family: 'Courier New', monospace;
  flex: 1 1;
}

.AdminCandidates_credPopupCopyBtn__-n3Jp {
  background: white;
  border: 1px solid var(--border);
  border-radius: 6px;
  padding: 0.4rem 0.55rem;
  cursor: pointer;
  font-size: 0.9rem;
  transition: all 0.2s;
  flex-shrink: 0;
}

.AdminCandidates_credPopupCopyBtn__-n3Jp:hover {
  background: var(--green-light);
  border-color: var(--green);
}

.AdminCandidates_credPopupWarning__RZErA {
  font-size: 0.75rem;
  color: #d35400;
  margin-top: 0.75rem;
  margin-bottom: 0;
}

.AdminCandidates_modalOverlay__2\\+xNu { position: fixed; inset: 0; background: rgba(0,0,0,0.45); z-index: 300; display: flex; align-items: center; justify-content: center; padding: 1rem; }
.AdminCandidates_modal__6xDCy { background: white; border-radius: var(--radius-lg); width: 100%; max-width: 420px; box-shadow: var(--shadow-lg); }
.AdminCandidates_modalHeader__YNq6I { display: flex; align-items: center; justify-content: space-between; padding: 1rem 1.25rem; border-bottom: 1px solid var(--border); }
.AdminCandidates_modalTitle__e2sXn { font-size: 0.95rem; font-weight: 600; color: var(--gray-900); font-family: 'DM Sans', sans-serif; }
.AdminCandidates_modalClose__yzbys { background: none; border: none; font-size: 1.2rem; color: var(--gray-500); line-height: 1; }
.AdminCandidates_formError__tzGpb { margin: 0.75rem 1.25rem 0; padding: 0.6rem 0.85rem; background: var(--red-light); color: var(--red); border-radius: var(--radius); font-size: 0.8rem; }
.AdminCandidates_form__HUMgA { padding: 1.25rem; display: flex; flex-direction: column; gap: 0.9rem; }
.AdminCandidates_field__bXs1e { display: flex; flex-direction: column; gap: 0.3rem; }
.AdminCandidates_label__hv7IV { font-size: 0.78rem; font-weight: 500; color: var(--gray-700); }
.AdminCandidates_input__897Pb, .AdminCandidates_select__IkncR { width: 100%; padding: 0.6rem 0.85rem; border: 1px solid var(--border); border-radius: var(--radius); font-size: 0.875rem; color: var(--gray-900); background: white; outline: none; }
.AdminCandidates_input__897Pb:focus, .AdminCandidates_select__IkncR:focus { border-color: var(--green); }
.AdminCandidates_modalActions__5e2k5 { display: flex; gap: 0.75rem; justify-content: flex-end; }
.AdminCandidates_cancelBtn__Nd2Da { padding: 0.55rem 1rem; background: transparent; border: 1px solid var(--border); border-radius: var(--radius); font-size: 0.82rem; color: var(--gray-700); }
.AdminCandidates_cancelBtn__Nd2Da:hover:not(:disabled) { background: var(--gray-50); }
.AdminCandidates_cancelBtn__Nd2Da:disabled { opacity: 0.6; cursor: not-allowed; }
.AdminCandidates_submitBtn__umcTj { padding: 0.55rem 1.1rem; background: var(--green); color: white; border: none; border-radius: var(--radius); font-size: 0.82rem; font-weight: 500; }
.AdminCandidates_submitBtn__umcTj:disabled { opacity: 0.6; cursor: not-allowed; }
.AdminCandidates_deleteBtn__UOzM- { padding: 0.55rem 1.1rem; background: var(--red); color: white; border: none; border-radius: var(--radius); font-size: 0.82rem; font-weight: 500; }
.AdminCandidates_deleteBtn__UOzM-:hover:not(:disabled) { background: #c0392b; box-shadow: 0 4px 12px rgba(192, 57, 43, 0.2); }
.AdminCandidates_deleteBtn__UOzM-:active:not(:disabled) { transform: scale(0.98); }
.AdminCandidates_deleteBtn__UOzM-:disabled { opacity: 0.6; cursor: not-allowed; }

.AdminCandidates_deactivateBtn__GDjjs { padding: 0.55rem 1.1rem; background: #f39c12; color: white; border: none; border-radius: var(--radius); font-size: 0.82rem; font-weight: 500; }
.AdminCandidates_deactivateBtn__GDjjs:hover:not(:disabled) { background: #e67e22; box-shadow: 0 4px 12px rgba(243, 156, 18, 0.2); }
.AdminCandidates_deactivateBtn__GDjjs:active:not(:disabled) { transform: scale(0.98); }
.AdminCandidates_deactivateBtn__GDjjs:disabled { opacity: 0.6; cursor: not-allowed; }

.AdminCandidates_tableCard__-zPs- { background: white; border: 1px solid var(--border); border-radius: var(--radius-lg); overflow: hidden; }
.AdminCandidates_tableWrap__j2x\\+9 { overflow-x: auto; }
.AdminCandidates_empty__\\+bujK { padding: 2.5rem 1.5rem; text-align: center; color: var(--gray-500); font-size: 0.82rem; }
.AdminCandidates_table__rM\\+nk { width: 100%; border-collapse: collapse; font-size: 0.8rem; }
.AdminCandidates_table__rM\\+nk th { padding: 0.6rem 1rem; text-align: left; font-size: 0.72rem; font-weight: 500; color: var(--gray-500); text-transform: capitalize; letter-spacing: 0.04em; border-bottom: 1px solid var(--border); white-space: nowrap; }
.AdminCandidates_table__rM\\+nk td { padding: 0.75rem 1rem; border-bottom: 1px solid var(--gray-50); vertical-align: middle; }
.AdminCandidates_table__rM\\+nk tr:last-child td { border-bottom: none; }
.AdminCandidates_table__rM\\+nk tr:hover td { background: var(--gray-50); }
.AdminCandidates_candidateCell__KMP-i { display: flex; align-items: center; gap: 0.6rem; }
.AdminCandidates_candidateName__hGLf5 { font-weight: 500; color: var(--gray-900); }
.AdminCandidates_candidateEmail__iO\\+50 { font-size: 0.72rem; color: var(--gray-500); }
.AdminCandidates_roleTag__X9g9U { display: inline-block; padding: 2px 8px; background: var(--gray-100); border-radius: 100px; font-size: 0.72rem; font-weight: 500; color: var(--gray-700); }
.AdminCandidates_statusTag__LQDqc { display: inline-block; padding: 2px 8px; border-radius: 100px; font-size: 0.72rem; font-weight: 500; }
.AdminCandidates_statusPending__1SpJs { background: var(--gray-100); color: var(--gray-700); }
.AdminCandidates_statusActive__G0bd7 { background: #fef3e2; color: #d35400; }
.AdminCandidates_statusDone__g88oE { background: var(--green-light); color: var(--green); }
.AdminCandidates_muted__DExo0 { color: var(--gray-500); }
.AdminCandidates_deleteIconBtn__qy3N5 { width: 26px; height: 26px; border-radius: var(--radius); border: 1px solid var(--border); background: transparent; color: var(--gray-500); font-size: 0.7rem; display: flex; align-items: center; justify-content: center; transition: all 0.12s; }
.AdminCandidates_deleteIconBtn__qy3N5:hover { background: var(--red-light); color: var(--red); border-color: transparent; }

.AdminCandidates_toggleBtn__OMNBA {
  padding: 0.4rem 0.8rem;
  border-radius: var(--radius);
  border: 1px solid var(--border);
  background: transparent;
  color: var(--gray-700);
  font-size: 0.78rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s;
}

.AdminCandidates_toggleBtn__OMNBA:hover:not(:disabled) {
  background: #f39c12;
  color: white;
  border-color: #f39c12;
}

.AdminCandidates_toggleBtn__OMNBA:active:not(:disabled) {
  transform: scale(0.95);
}

.AdminCandidates_toggleBtn__OMNBA:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.AdminCandidates_toggleBtnInactive__6rFiN {
  background: var(--green-light);
  color: var(--green);
  border-color: var(--green-light);
}

.AdminCandidates_toggleBtnInactive__6rFiN:hover:not(:disabled) {
  background: var(--green);
  color: white;
  border-color: var(--green);
}

.AdminCandidates_assessmentToggleBtn__UNVXs {
  padding: 0.4rem 0.65rem;
  border-radius: var(--radius);
  border: 1px solid #d97706;
  background: #fff7ed;
  color: #b45309;
  font-size: 0.74rem;
  font-weight: 500;
  white-space: nowrap;
  cursor: pointer;
}

.AdminCandidates_assessmentToggleBtn__UNVXs:hover:not(:disabled) {
  background: #d97706;
  color: white;
}

.AdminCandidates_assessmentToggleBtn__UNVXs:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.AdminCandidates_assessmentResumeBtn__NzB6z {
  border-color: var(--green);
  background: var(--green-light);
  color: var(--green);
}

.AdminCandidates_assessmentResumeBtn__NzB6z:hover:not(:disabled) {
  background: var(--green);
  color: white;
}

.AdminCandidates_codeCell__BUR5k {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.AdminCandidates_codeValue__mhnD6 {
  font-family: 'Courier New', monospace;
  font-weight: 600;
  font-size: 0.82rem;
  color: var(--green);
  letter-spacing: 0.05em;
  background: var(--gray-50);
  padding: 3px 8px;
  border-radius: 4px;
  border: 1px solid rgba(26,92,56,0.1);
}

.AdminCandidates_copyBtn__oeFxp {
  width: 24px;
  height: 24px;
  border-radius: 4px;
  border: 1px solid var(--border);
  background: white;
  color: var(--gray-600);
  font-size: 0.75rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s;
  flex-shrink: 0;
}

.AdminCandidates_copyBtn__oeFxp:hover {
  background: var(--green-light);
  border-color: var(--green);
  color: var(--green);
}

.AdminCandidates_copyBtn__oeFxp:active {
  background: var(--green);
  color: white;
  border-color: var(--green);
}

/* Delete Modal Styling */
.AdminCandidates_deleteModalContent__jEBt1 {
  padding: 2rem 1.5rem;
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.AdminCandidates_deleteIcon__MiVOR {
  font-size: 3rem;
  line-height: 1;
  animation: AdminCandidates_shake__dhxWZ 0.4s ease-in-out;
}

@keyframes AdminCandidates_shake__dhxWZ {
  0%, 100% { transform: translateX(0); }
  25% { transform: translateX(-5px); }
  75% { transform: translateX(5px); }
}

.AdminCandidates_deleteTitle__PpBuD {
  font-size: 1.15rem;
  font-weight: 600;
  color: var(--gray-900);
  margin: 0;
}

.AdminCandidates_deleteMessage__UL8Br {
  font-size: 0.9rem;
  color: var(--gray-700);
  margin: 0;
  line-height: 1.5;
}

.AdminCandidates_deleteWarning__xumfM {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.6rem;
  padding: 0.75rem 1rem;
  background: #fef3e2;
  border: 1px solid #ffd699;
  border-radius: var(--radius);
  color: #d35400;
  font-size: 0.85rem;
  font-weight: 500;
}

.AdminCandidates_deleteWarning__xumfM span:first-child {
  font-size: 1rem;
}

.AdminCandidates_modalActions__5e2k5 {
  display: flex;
  gap: 0.75rem;
  justify-content: center;
  padding-top: 0.5rem;
}

.AdminCandidates_modalActions__5e2k5 .AdminCandidates_cancelBtn__Nd2Da {
  padding: 0.6rem 1.5rem;
  background: white;
  border: 1.5px solid var(--border);
  color: var(--gray-700);
  font-weight: 500;
  transition: all 0.15s;
}

.AdminCandidates_modalActions__5e2k5 .AdminCandidates_cancelBtn__Nd2Da:hover {
  background: var(--gray-50);
  border-color: var(--gray-300);
}

.AdminCandidates_modalActions__5e2k5 .AdminCandidates_deleteBtn__UOzM- {
  padding: 0.6rem 1.5rem;
  background: var(--red);
  color: white;
  font-weight: 500;
  transition: all 0.15s;
  box-shadow: 0 2px 8px rgba(192, 57, 43, 0.15);
}

.AdminCandidates_modalActions__5e2k5 .AdminCandidates_deleteBtn__UOzM-:hover {
  background: #c0392b;
  box-shadow: 0 4px 12px rgba(192, 57, 43, 0.25);
  transform: translateY(-1px);
}

.AdminCandidates_modalActions__5e2k5 .AdminCandidates_deleteBtn__UOzM-:active {
  transform: translateY(0);
  box-shadow: 0 2px 4px rgba(192, 57, 43, 0.15);
}

.AdminCandidates_modalActions__5e2k5 .AdminCandidates_deactivateBtn__GDjjs {
  padding: 0.6rem 1.5rem;
  background: #f39c12;
  color: white;
  font-weight: 500;
  transition: all 0.15s;
  box-shadow: 0 2px 8px rgba(243, 156, 18, 0.15);
}

.AdminCandidates_modalActions__5e2k5 .AdminCandidates_deactivateBtn__GDjjs:hover {
  background: #e67e22;
  box-shadow: 0 4px 12px rgba(243, 156, 18, 0.25);
  transform: translateY(-1px);
}

.AdminCandidates_modalActions__5e2k5 .AdminCandidates_deactivateBtn__GDjjs:active {
  transform: translateY(0);
  box-shadow: 0 2px 4px rgba(243, 156, 18, 0.15);
}
`, "",{"version":3,"sources":["webpack://./src/pages/admin/AdminCandidates.module.css"],"names":[],"mappings":"AAAA,+BAAQ,iBAAiB,EAAE;AAC3B,qCAAc,aAAa,EAAE,uBAAuB,EAAE,8BAA8B,EAAE,sBAAsB,EAAE,SAAS,EAAE,eAAe,EAAE;AAC1I,qCAAa,iBAAiB,EAAE,mBAAmB,EAAE,qBAAqB,EAAE;AAC5E,kCAAW,iBAAiB,EAAE,sBAAsB,EAAE;AACtD,qCAAa,qBAAqB,EAAE,wBAAwB,EAAE,YAAY,EAAE,YAAY,EAAE,4BAA4B,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,4BAA4B,EAAE;AAC5L,2CAAmB,mBAAmB,EAAE;;AAExC,oCAAa,uBAAuB,EAAE,uBAAuB,EAAE,+BAA+B,EAAE,oBAAoB,EAAE,kBAAkB,EAAE,sBAAsB,EAAE,qBAAqB,EAAE;AACzL,0CAAmB,0BAA0B,EAAE;AAC/C,kEAAoB,wBAAwB,EAAE,YAAY,EAAE,0BAA0B,EAAE;AACxF,sCAAe,YAAY,EAAE,iBAAiB,EAAE,cAAc,EAAE;AAChE,sGAAiC,YAAY,EAAE;;AAE/C,sCAAa,sBAAsB,EAAE,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,eAAe,EAAE;AACrG,wCAAiB,aAAa,EAAE,WAAW,EAAE,eAAe,EAAE;AAC9D,sCAAe,oBAAoB,EAAE,+BAA+B,EAAE,4BAA4B,EAAE,kBAAkB,EAAE,sBAAsB,EAAE,8BAA8B,EAAE,SAAO,EAAE,gBAAgB,EAAE;AAC3M,4CAAqB,aAAa,EAAE,0BAA0B,EAAE;AAChE,mDAA4B,sBAAsB,EAAE;;AAEpD;EACE,qCAAqC;EACrC,+BAA+B;EAC/B,8BAA8B;EAC9B,sBAAsB;EACtB,gBAAgB;AAClB;AACA,qCAAc,aAAa,EAAE,mBAAmB,EAAE,8BAA8B,EAAE,qBAAqB,EAAE,4CAA4C,EAAE;AACvJ,oCAAa,kBAAkB,EAAE,gBAAgB,EAAE,mBAAmB,EAAE;AACxE,oCAAa,gBAAgB,EAAE,YAAY,EAAE,mBAAmB,EAAE,iBAAiB,EAAE,cAAc,EAAE;AACrG,mCAAY,aAAa,EAAE;AAC3B,mCAAY,kBAAkB,EAAE,sBAAsB,EAAE,sBAAsB,EAAE;AAChF,sCAAe,aAAa,EAAE,sBAAsB,EAAE,WAAW,EAAE,sBAAsB,EAAE;AAC3F,kCAAW,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE;AAC1D,kCAAW,kBAAkB,EAAE,sBAAsB,EAAE,YAAY,EAAE,cAAc,EAAE;AACrF,oCAAa,kBAAkB,EAAE,sBAAsB,EAAE;AACzD,yCAAgB,iBAAiB,EAAE,gBAAgB,EAAE,mBAAmB,EAAE,qBAAqB,EAAE,qCAAqC,EAAE,iBAAiB,EAAE,iBAAiB,EAAE,kBAAkB,EAAE,oCAAoC,EAAE;AACxO,uCAAe,kBAAkB,EAAE,cAAc,EAAE;;AAEnD;EACE,qCAAqC;EACrC,+BAA+B;EAC/B,8BAA8B;EAC9B,sBAAsB;EACtB,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,qDAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,0BAA0B;AAC1B;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,2CAA2C;EAC3C,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,iDAA0B;AAC5B;;AAEA;EACE;IACE,UAAU;IACV,sBAAsB;EACxB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,sBAAsB;EACtB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,qCAAqC;EACrC,SAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,wCAAgB,eAAe,EAAE,QAAQ,EAAE,4BAA4B,EAAE,YAAY,EAAE,aAAa,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,aAAa,EAAE;AACnK,gCAAS,iBAAiB,EAAE,+BAA+B,EAAE,WAAW,EAAE,gBAAgB,EAAE,4BAA4B,EAAE;AAC1H,sCAAe,aAAa,EAAE,mBAAmB,EAAE,8BAA8B,EAAE,qBAAqB,EAAE,sCAAsC,EAAE;AAClJ,qCAAc,kBAAkB,EAAE,gBAAgB,EAAE,sBAAsB,EAAE,kCAAkC,EAAE;AAChH,qCAAc,gBAAgB,EAAE,YAAY,EAAE,iBAAiB,EAAE,sBAAsB,EAAE,cAAc,EAAE;AACzG,oCAAa,yBAAyB,EAAE,uBAAuB,EAAE,4BAA4B,EAAE,iBAAiB,EAAE,4BAA4B,EAAE,iBAAiB,EAAE;AACnK,+BAAQ,gBAAgB,EAAE,aAAa,EAAE,sBAAsB,EAAE,WAAW,EAAE;AAC9E,gCAAS,aAAa,EAAE,sBAAsB,EAAE,WAAW,EAAE;AAC7D,gCAAS,kBAAkB,EAAE,gBAAgB,EAAE,sBAAsB,EAAE;AACvE,gEAAkB,WAAW,EAAE,uBAAuB,EAAE,+BAA+B,EAAE,4BAA4B,EAAE,mBAAmB,EAAE,sBAAsB,EAAE,iBAAiB,EAAE,aAAa,EAAE;AACtM,4EAA8B,0BAA0B,EAAE;AAC1D,uCAAgB,aAAa,EAAE,YAAY,EAAE,yBAAyB,EAAE;AACxE,oCAAa,qBAAqB,EAAE,uBAAuB,EAAE,+BAA+B,EAAE,4BAA4B,EAAE,kBAAkB,EAAE,sBAAsB,EAAE;AACxK,yDAAkC,0BAA0B,EAAE;AAC9D,6CAAsB,YAAY,EAAE,mBAAmB,EAAE;AACzD,oCAAa,uBAAuB,EAAE,wBAAwB,EAAE,YAAY,EAAE,YAAY,EAAE,4BAA4B,EAAE,kBAAkB,EAAE,gBAAgB,EAAE;AAChK,6CAAsB,YAAY,EAAE,mBAAmB,EAAE;AACzD,oCAAa,uBAAuB,EAAE,sBAAsB,EAAE,YAAY,EAAE,YAAY,EAAE,4BAA4B,EAAE,kBAAkB,EAAE,gBAAgB,EAAE;AAC9J,yDAAkC,mBAAmB,EAAE,6CAA6C,EAAE;AACtG,0DAAmC,sBAAsB,EAAE;AAC3D,6CAAsB,YAAY,EAAE,mBAAmB,EAAE;;AAEzD,wCAAiB,uBAAuB,EAAE,mBAAmB,EAAE,YAAY,EAAE,YAAY,EAAE,4BAA4B,EAAE,kBAAkB,EAAE,gBAAgB,EAAE;AAC/J,6DAAsC,mBAAmB,EAAE,8CAA8C,EAAE;AAC3G,8DAAuC,sBAAsB,EAAE;AAC/D,iDAA0B,YAAY,EAAE,mBAAmB,EAAE;;AAE7D,oCAAa,iBAAiB,EAAE,+BAA+B,EAAE,+BAA+B,EAAE,gBAAgB,EAAE;AACpH,qCAAa,gBAAgB,EAAE;AAC/B,iCAAS,sBAAsB,EAAE,kBAAkB,EAAE,sBAAsB,EAAE,kBAAkB,EAAE;AACjG,iCAAS,WAAW,EAAE,yBAAyB,EAAE,iBAAiB,EAAE;AACpE,oCAAY,oBAAoB,EAAE,gBAAgB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,sBAAsB,EAAE,0BAA0B,EAAE,sBAAsB,EAAE,sCAAsC,EAAE,mBAAmB,EAAE;AACnO,oCAAY,qBAAqB,EAAE,uCAAuC,EAAE,sBAAsB,EAAE;AACpG,kDAA0B,mBAAmB,EAAE;AAC/C,6CAAqB,0BAA0B,EAAE;AACjD,wCAAiB,aAAa,EAAE,mBAAmB,EAAE,WAAW,EAAE;AAClE,wCAAiB,gBAAgB,EAAE,sBAAsB,EAAE;AAC3D,0CAAkB,kBAAkB,EAAE,sBAAsB,EAAE;AAC9D,kCAAW,qBAAqB,EAAE,gBAAgB,EAAE,2BAA2B,EAAE,oBAAoB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,sBAAsB,EAAE;AACrK,oCAAa,qBAAqB,EAAE,gBAAgB,EAAE,oBAAoB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE;AAClH,wCAAiB,2BAA2B,EAAE,sBAAsB,EAAE;AACtE,uCAAgB,mBAAmB,EAAE,cAAc,EAAE;AACrD,qCAAc,8BAA8B,EAAE,mBAAmB,EAAE;AACnE,gCAAS,sBAAsB,EAAE;AACjC,wCAAiB,WAAW,EAAE,YAAY,EAAE,4BAA4B,EAAE,+BAA+B,EAAE,uBAAuB,EAAE,sBAAsB,EAAE,iBAAiB,EAAE,aAAa,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,qBAAqB,EAAE;AACnQ,8CAAuB,4BAA4B,EAAE,iBAAiB,EAAE,yBAAyB,EAAE;;AAEnG;EACE,sBAAsB;EACtB,4BAA4B;EAC5B,+BAA+B;EAC/B,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,wBAAwB;EACxB,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,0BAA0B;EAC1B,gBAAgB;EAChB,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;EAC/B,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,YAAY;EACZ,0BAA0B;AAC5B;;AAEA,yBAAyB;AACzB;EACE,oBAAoB;EACpB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,wDAAiC;AACnC;;AAEA;EACE,WAAW,wBAAwB,EAAE;EACrC,MAAM,2BAA2B,EAAE;EACnC,MAAM,0BAA0B,EAAE;AACpC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,qBAAqB;EACrB,mBAAmB;EACnB,yBAAyB;EACzB,4BAA4B;EAC5B,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,iCAAiC;EACjC,sBAAsB;EACtB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,6CAA6C;AAC/C;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,+CAA+C;EAC/C,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,8CAA8C;AAChD","sourcesContent":[".page { max-width: 1600px; }\n.pageHeader { display: flex; align-items: flex-start; justify-content: space-between; margin-bottom: 1.25rem; gap: 1rem; flex-wrap: wrap; }\n.pageTitle { font-size: 1.4rem; color: var(--black); margin-bottom: 0.2rem; }\n.pageSub { font-size: 0.8rem; color: var(--gray-500); }\n.actionBtn { padding: 0.55rem 1rem; background: var(--green); color: white; border: none; border-radius: var(--radius); font-size: 0.82rem; font-weight: 500; transition: background 0.15s; }\n.actionBtn:hover { background: #155a30; }\n\n.filterBtn { padding: 0.4rem 0.85rem; background: transparent; border: 1px solid var(--border); border-radius: 100px; font-size: 0.78rem; color: var(--gray-700); transition: all 0.12s; }\n.filterBtn:hover { background: var(--gray-50); }\n.filterBtn.active { background: var(--green); color: white; border-color: var(--green); }\n.filterCount { opacity: 0.7; font-size: 0.7rem; color: #dc2626; }\n.filterBtn.active .filterCount { color: white; }\n\n.searchBar { margin-bottom: 1.25rem; display: flex; align-items: center; gap: 1rem; flex-wrap: wrap; }\n.filtersInline { display: flex; gap: 0.5rem; flex-wrap: wrap; }\n.searchInput { padding: 0.6rem 1rem; border: 1px solid var(--border); border-radius: var(--radius); font-size: 0.82rem; color: var(--gray-900); transition: border-color 0.15s; flex: 1; min-width: 200px; }\n.searchInput:focus { outline: none; border-color: var(--green); }\n.searchInput::placeholder { color: var(--gray-400); }\n\n.credBox {\n  border: 1px solid rgba(26,92,56,0.25);\n  border-radius: var(--radius-lg);\n  background: var(--green-light);\n  margin-bottom: 1.25rem;\n  overflow: hidden;\n}\n.credHeader { display: flex; align-items: center; justify-content: space-between; padding: 0.75rem 1rem; border-bottom: 1px solid rgba(26,92,56,0.15); }\n.credTitle { font-size: 0.82rem; font-weight: 600; color: var(--green); }\n.credClose { background: none; border: none; color: var(--green); font-size: 1.1rem; line-height: 1; }\n.credBody { padding: 1rem; }\n.credText { font-size: 0.82rem; color: var(--gray-700); margin-bottom: 0.85rem; }\n.credDetails { display: flex; flex-direction: column; gap: 0.5rem; margin-bottom: 0.85rem; }\n.credRow { display: flex; align-items: center; gap: 1rem; }\n.credKey { font-size: 0.75rem; color: var(--gray-500); width: 200px; flex-shrink: 0; }\n.credValue { font-size: 0.82rem; color: var(--gray-900); }\n.credPassword { font-size: 1.1rem; font-weight: 700; color: var(--green); letter-spacing: 0.1em; font-family: 'Courier New', monospace; background: white; padding: 4px 12px; border-radius: 6px; border: 1px solid rgba(26,92,56,0.2); }\n.credWarning { font-size: 0.75rem; color: #d35400; }\n\n.successBox {\n  border: 1px solid rgba(26,92,56,0.25);\n  border-radius: var(--radius-lg);\n  background: var(--green-light);\n  margin-bottom: 1.25rem;\n  padding: 0.85rem 1rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.65rem;\n  animation: slideDown 0.3s ease;\n}\n\n.successContent {\n  display: flex;\n  align-items: center;\n  gap: 0.65rem;\n}\n\n.successIcon {\n  font-size: 1rem;\n  color: var(--green);\n  font-weight: bold;\n}\n\n.successText {\n  font-size: 0.82rem;\n  font-weight: 600;\n  color: var(--green);\n}\n\n@keyframes slideDown {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Credential Popup Card */\n.credPopupOverlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.4);\n  z-index: 1000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1rem;\n}\n\n.credPopupCard {\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);\n  max-width: 320px;\n  width: 100%;\n  position: relative;\n  animation: popUp 0.3s ease;\n}\n\n@keyframes popUp {\n  from {\n    opacity: 0;\n    transform: scale(0.95);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n.credPopupClose {\n  position: absolute;\n  top: 0.5rem;\n  right: 0.5rem;\n  background: none;\n  border: none;\n  font-size: 1.5rem;\n  color: var(--gray-400);\n  cursor: pointer;\n  transition: color 0.2s;\n}\n\n.credPopupClose:hover {\n  color: var(--gray-600);\n}\n\n.credPopupContent {\n  padding: 1.25rem 1rem;\n  text-align: center;\n}\n\n.credPopupIcon {\n  font-size: 1.8rem;\n  margin-bottom: 0.3rem;\n  display: block;\n}\n\n.credPopupTitle {\n  font-size: 0.95rem;\n  font-weight: 600;\n  color: var(--black);\n  margin-bottom: 0.15rem;\n}\n\n.credPopupSubtitle {\n  font-size: 0.8rem;\n  color: var(--gray-500);\n  margin-bottom: 0.85rem;\n}\n\n.credPopupItem {\n  text-align: left;\n  margin-bottom: 0.7rem;\n  padding: 0.6rem;\n  background: var(--gray-50);\n  border-radius: 6px;\n}\n\n.credPopupLabel {\n  display: block;\n  font-size: 0.7rem;\n  font-weight: 600;\n  color: var(--gray-500);\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  margin-bottom: 0.35rem;\n}\n\n.credPopupValue {\n  display: block;\n  font-size: 0.8rem;\n  color: var(--gray-900);\n  word-break: break-all;\n}\n\n.credPopupCopyRow {\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  justify-content: space-between;\n}\n\n.credPopupCode {\n  display: block;\n  font-size: 1.1rem;\n  font-weight: 700;\n  color: var(--green);\n  letter-spacing: 0.15em;\n  font-family: 'Courier New', monospace;\n  flex: 1;\n}\n\n.credPopupCopyBtn {\n  background: white;\n  border: 1px solid var(--border);\n  border-radius: 6px;\n  padding: 0.4rem 0.55rem;\n  cursor: pointer;\n  font-size: 0.9rem;\n  transition: all 0.2s;\n  flex-shrink: 0;\n}\n\n.credPopupCopyBtn:hover {\n  background: var(--green-light);\n  border-color: var(--green);\n}\n\n.credPopupWarning {\n  font-size: 0.75rem;\n  color: #d35400;\n  margin-top: 0.75rem;\n  margin-bottom: 0;\n}\n\n.modalOverlay { position: fixed; inset: 0; background: rgba(0,0,0,0.45); z-index: 300; display: flex; align-items: center; justify-content: center; padding: 1rem; }\n.modal { background: white; border-radius: var(--radius-lg); width: 100%; max-width: 420px; box-shadow: var(--shadow-lg); }\n.modalHeader { display: flex; align-items: center; justify-content: space-between; padding: 1rem 1.25rem; border-bottom: 1px solid var(--border); }\n.modalTitle { font-size: 0.95rem; font-weight: 600; color: var(--gray-900); font-family: 'DM Sans', sans-serif; }\n.modalClose { background: none; border: none; font-size: 1.2rem; color: var(--gray-500); line-height: 1; }\n.formError { margin: 0.75rem 1.25rem 0; padding: 0.6rem 0.85rem; background: var(--red-light); color: var(--red); border-radius: var(--radius); font-size: 0.8rem; }\n.form { padding: 1.25rem; display: flex; flex-direction: column; gap: 0.9rem; }\n.field { display: flex; flex-direction: column; gap: 0.3rem; }\n.label { font-size: 0.78rem; font-weight: 500; color: var(--gray-700); }\n.input, .select { width: 100%; padding: 0.6rem 0.85rem; border: 1px solid var(--border); border-radius: var(--radius); font-size: 0.875rem; color: var(--gray-900); background: white; outline: none; }\n.input:focus, .select:focus { border-color: var(--green); }\n.modalActions { display: flex; gap: 0.75rem; justify-content: flex-end; }\n.cancelBtn { padding: 0.55rem 1rem; background: transparent; border: 1px solid var(--border); border-radius: var(--radius); font-size: 0.82rem; color: var(--gray-700); }\n.cancelBtn:hover:not(:disabled) { background: var(--gray-50); }\n.cancelBtn:disabled { opacity: 0.6; cursor: not-allowed; }\n.submitBtn { padding: 0.55rem 1.1rem; background: var(--green); color: white; border: none; border-radius: var(--radius); font-size: 0.82rem; font-weight: 500; }\n.submitBtn:disabled { opacity: 0.6; cursor: not-allowed; }\n.deleteBtn { padding: 0.55rem 1.1rem; background: var(--red); color: white; border: none; border-radius: var(--radius); font-size: 0.82rem; font-weight: 500; }\n.deleteBtn:hover:not(:disabled) { background: #c0392b; box-shadow: 0 4px 12px rgba(192, 57, 43, 0.2); }\n.deleteBtn:active:not(:disabled) { transform: scale(0.98); }\n.deleteBtn:disabled { opacity: 0.6; cursor: not-allowed; }\n\n.deactivateBtn { padding: 0.55rem 1.1rem; background: #f39c12; color: white; border: none; border-radius: var(--radius); font-size: 0.82rem; font-weight: 500; }\n.deactivateBtn:hover:not(:disabled) { background: #e67e22; box-shadow: 0 4px 12px rgba(243, 156, 18, 0.2); }\n.deactivateBtn:active:not(:disabled) { transform: scale(0.98); }\n.deactivateBtn:disabled { opacity: 0.6; cursor: not-allowed; }\n\n.tableCard { background: white; border: 1px solid var(--border); border-radius: var(--radius-lg); overflow: hidden; }\n.tableWrap { overflow-x: auto; }\n.empty { padding: 2.5rem 1.5rem; text-align: center; color: var(--gray-500); font-size: 0.82rem; }\n.table { width: 100%; border-collapse: collapse; font-size: 0.8rem; }\n.table th { padding: 0.6rem 1rem; text-align: left; font-size: 0.72rem; font-weight: 500; color: var(--gray-500); text-transform: capitalize; letter-spacing: 0.04em; border-bottom: 1px solid var(--border); white-space: nowrap; }\n.table td { padding: 0.75rem 1rem; border-bottom: 1px solid var(--gray-50); vertical-align: middle; }\n.table tr:last-child td { border-bottom: none; }\n.table tr:hover td { background: var(--gray-50); }\n.candidateCell { display: flex; align-items: center; gap: 0.6rem; }\n.candidateName { font-weight: 500; color: var(--gray-900); }\n.candidateEmail { font-size: 0.72rem; color: var(--gray-500); }\n.roleTag { display: inline-block; padding: 2px 8px; background: var(--gray-100); border-radius: 100px; font-size: 0.72rem; font-weight: 500; color: var(--gray-700); }\n.statusTag { display: inline-block; padding: 2px 8px; border-radius: 100px; font-size: 0.72rem; font-weight: 500; }\n.statusPending { background: var(--gray-100); color: var(--gray-700); }\n.statusActive { background: #fef3e2; color: #d35400; }\n.statusDone { background: var(--green-light); color: var(--green); }\n.muted { color: var(--gray-500); }\n.deleteIconBtn { width: 26px; height: 26px; border-radius: var(--radius); border: 1px solid var(--border); background: transparent; color: var(--gray-500); font-size: 0.7rem; display: flex; align-items: center; justify-content: center; transition: all 0.12s; }\n.deleteIconBtn:hover { background: var(--red-light); color: var(--red); border-color: transparent; }\n\n.toggleBtn {\n  padding: 0.4rem 0.8rem;\n  border-radius: var(--radius);\n  border: 1px solid var(--border);\n  background: transparent;\n  color: var(--gray-700);\n  font-size: 0.78rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.15s;\n}\n\n.toggleBtn:hover:not(:disabled) {\n  background: #f39c12;\n  color: white;\n  border-color: #f39c12;\n}\n\n.toggleBtn:active:not(:disabled) {\n  transform: scale(0.95);\n}\n\n.toggleBtn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.toggleBtnInactive {\n  background: var(--green-light);\n  color: var(--green);\n  border-color: var(--green-light);\n}\n\n.toggleBtnInactive:hover:not(:disabled) {\n  background: var(--green);\n  color: white;\n  border-color: var(--green);\n}\n\n.assessmentToggleBtn {\n  padding: 0.4rem 0.65rem;\n  border-radius: var(--radius);\n  border: 1px solid #d97706;\n  background: #fff7ed;\n  color: #b45309;\n  font-size: 0.74rem;\n  font-weight: 500;\n  white-space: nowrap;\n  cursor: pointer;\n}\n\n.assessmentToggleBtn:hover:not(:disabled) {\n  background: #d97706;\n  color: white;\n}\n\n.assessmentToggleBtn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.assessmentResumeBtn {\n  border-color: var(--green);\n  background: var(--green-light);\n  color: var(--green);\n}\n\n.assessmentResumeBtn:hover:not(:disabled) {\n  background: var(--green);\n  color: white;\n}\n\n.codeCell {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.codeValue {\n  font-family: 'Courier New', monospace;\n  font-weight: 600;\n  font-size: 0.82rem;\n  color: var(--green);\n  letter-spacing: 0.05em;\n  background: var(--gray-50);\n  padding: 3px 8px;\n  border-radius: 4px;\n  border: 1px solid rgba(26,92,56,0.1);\n}\n\n.copyBtn {\n  width: 24px;\n  height: 24px;\n  border-radius: 4px;\n  border: 1px solid var(--border);\n  background: white;\n  color: var(--gray-600);\n  font-size: 0.75rem;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.15s;\n  flex-shrink: 0;\n}\n\n.copyBtn:hover {\n  background: var(--green-light);\n  border-color: var(--green);\n  color: var(--green);\n}\n\n.copyBtn:active {\n  background: var(--green);\n  color: white;\n  border-color: var(--green);\n}\n\n/* Delete Modal Styling */\n.deleteModalContent {\n  padding: 2rem 1.5rem;\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.deleteIcon {\n  font-size: 3rem;\n  line-height: 1;\n  animation: shake 0.4s ease-in-out;\n}\n\n@keyframes shake {\n  0%, 100% { transform: translateX(0); }\n  25% { transform: translateX(-5px); }\n  75% { transform: translateX(5px); }\n}\n\n.deleteTitle {\n  font-size: 1.15rem;\n  font-weight: 600;\n  color: var(--gray-900);\n  margin: 0;\n}\n\n.deleteMessage {\n  font-size: 0.9rem;\n  color: var(--gray-700);\n  margin: 0;\n  line-height: 1.5;\n}\n\n.deleteWarning {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.6rem;\n  padding: 0.75rem 1rem;\n  background: #fef3e2;\n  border: 1px solid #ffd699;\n  border-radius: var(--radius);\n  color: #d35400;\n  font-size: 0.85rem;\n  font-weight: 500;\n}\n\n.deleteWarning span:first-child {\n  font-size: 1rem;\n}\n\n.modalActions {\n  display: flex;\n  gap: 0.75rem;\n  justify-content: center;\n  padding-top: 0.5rem;\n}\n\n.modalActions .cancelBtn {\n  padding: 0.6rem 1.5rem;\n  background: white;\n  border: 1.5px solid var(--border);\n  color: var(--gray-700);\n  font-weight: 500;\n  transition: all 0.15s;\n}\n\n.modalActions .cancelBtn:hover {\n  background: var(--gray-50);\n  border-color: var(--gray-300);\n}\n\n.modalActions .deleteBtn {\n  padding: 0.6rem 1.5rem;\n  background: var(--red);\n  color: white;\n  font-weight: 500;\n  transition: all 0.15s;\n  box-shadow: 0 2px 8px rgba(192, 57, 43, 0.15);\n}\n\n.modalActions .deleteBtn:hover {\n  background: #c0392b;\n  box-shadow: 0 4px 12px rgba(192, 57, 43, 0.25);\n  transform: translateY(-1px);\n}\n\n.modalActions .deleteBtn:active {\n  transform: translateY(0);\n  box-shadow: 0 2px 4px rgba(192, 57, 43, 0.15);\n}\n\n.modalActions .deactivateBtn {\n  padding: 0.6rem 1.5rem;\n  background: #f39c12;\n  color: white;\n  font-weight: 500;\n  transition: all 0.15s;\n  box-shadow: 0 2px 8px rgba(243, 156, 18, 0.15);\n}\n\n.modalActions .deactivateBtn:hover {\n  background: #e67e22;\n  box-shadow: 0 4px 12px rgba(243, 156, 18, 0.25);\n  transform: translateY(-1px);\n}\n\n.modalActions .deactivateBtn:active {\n  transform: translateY(0);\n  box-shadow: 0 2px 4px rgba(243, 156, 18, 0.15);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `AdminCandidates_page__inl85`,
	"pageHeader": `AdminCandidates_pageHeader__amqEM`,
	"pageTitle": `AdminCandidates_pageTitle__ZHhk+`,
	"pageSub": `AdminCandidates_pageSub__gOZtf`,
	"actionBtn": `AdminCandidates_actionBtn__oM+zp`,
	"filterBtn": `AdminCandidates_filterBtn__Sxc2x`,
	"active": `AdminCandidates_active__tzc09`,
	"filterCount": `AdminCandidates_filterCount__y0Y-l`,
	"searchBar": `AdminCandidates_searchBar__+i+u6`,
	"filtersInline": `AdminCandidates_filtersInline__RllPR`,
	"searchInput": `AdminCandidates_searchInput__iBuhh`,
	"credBox": `AdminCandidates_credBox__mB5OF`,
	"credHeader": `AdminCandidates_credHeader__MNQ9g`,
	"credTitle": `AdminCandidates_credTitle__K6L-0`,
	"credClose": `AdminCandidates_credClose__Pzmha`,
	"credBody": `AdminCandidates_credBody__Vc-nG`,
	"credText": `AdminCandidates_credText__vwEPw`,
	"credDetails": `AdminCandidates_credDetails__nHVCX`,
	"credRow": `AdminCandidates_credRow__u5agf`,
	"credKey": `AdminCandidates_credKey__s-Aid`,
	"credValue": `AdminCandidates_credValue__2Xvmq`,
	"credPassword": `AdminCandidates_credPassword__++f2F`,
	"credWarning": `AdminCandidates_credWarning__-id+B`,
	"successBox": `AdminCandidates_successBox__ywIed`,
	"slideDown": `AdminCandidates_slideDown__uaJDy`,
	"successContent": `AdminCandidates_successContent__LUgta`,
	"successIcon": `AdminCandidates_successIcon__I-c4V`,
	"successText": `AdminCandidates_successText__F25fk`,
	"credPopupOverlay": `AdminCandidates_credPopupOverlay__BdvUq`,
	"credPopupCard": `AdminCandidates_credPopupCard__5vKhl`,
	"popUp": `AdminCandidates_popUp__0ZoXo`,
	"credPopupClose": `AdminCandidates_credPopupClose__9lv2x`,
	"credPopupContent": `AdminCandidates_credPopupContent__1Ou2-`,
	"credPopupIcon": `AdminCandidates_credPopupIcon__NmVzb`,
	"credPopupTitle": `AdminCandidates_credPopupTitle__2d3sO`,
	"credPopupSubtitle": `AdminCandidates_credPopupSubtitle__lTJjW`,
	"credPopupItem": `AdminCandidates_credPopupItem__CU7ah`,
	"credPopupLabel": `AdminCandidates_credPopupLabel__OSpSI`,
	"credPopupValue": `AdminCandidates_credPopupValue__-S-xc`,
	"credPopupCopyRow": `AdminCandidates_credPopupCopyRow__hfYLl`,
	"credPopupCode": `AdminCandidates_credPopupCode__ycfE8`,
	"credPopupCopyBtn": `AdminCandidates_credPopupCopyBtn__-n3Jp`,
	"credPopupWarning": `AdminCandidates_credPopupWarning__RZErA`,
	"modalOverlay": `AdminCandidates_modalOverlay__2+xNu`,
	"modal": `AdminCandidates_modal__6xDCy`,
	"modalHeader": `AdminCandidates_modalHeader__YNq6I`,
	"modalTitle": `AdminCandidates_modalTitle__e2sXn`,
	"modalClose": `AdminCandidates_modalClose__yzbys`,
	"formError": `AdminCandidates_formError__tzGpb`,
	"form": `AdminCandidates_form__HUMgA`,
	"field": `AdminCandidates_field__bXs1e`,
	"label": `AdminCandidates_label__hv7IV`,
	"input": `AdminCandidates_input__897Pb`,
	"select": `AdminCandidates_select__IkncR`,
	"modalActions": `AdminCandidates_modalActions__5e2k5`,
	"cancelBtn": `AdminCandidates_cancelBtn__Nd2Da`,
	"submitBtn": `AdminCandidates_submitBtn__umcTj`,
	"deleteBtn": `AdminCandidates_deleteBtn__UOzM-`,
	"deactivateBtn": `AdminCandidates_deactivateBtn__GDjjs`,
	"tableCard": `AdminCandidates_tableCard__-zPs-`,
	"tableWrap": `AdminCandidates_tableWrap__j2x+9`,
	"empty": `AdminCandidates_empty__+bujK`,
	"table": `AdminCandidates_table__rM+nk`,
	"candidateCell": `AdminCandidates_candidateCell__KMP-i`,
	"candidateName": `AdminCandidates_candidateName__hGLf5`,
	"candidateEmail": `AdminCandidates_candidateEmail__iO+50`,
	"roleTag": `AdminCandidates_roleTag__X9g9U`,
	"statusTag": `AdminCandidates_statusTag__LQDqc`,
	"statusPending": `AdminCandidates_statusPending__1SpJs`,
	"statusActive": `AdminCandidates_statusActive__G0bd7`,
	"statusDone": `AdminCandidates_statusDone__g88oE`,
	"muted": `AdminCandidates_muted__DExo0`,
	"deleteIconBtn": `AdminCandidates_deleteIconBtn__qy3N5`,
	"toggleBtn": `AdminCandidates_toggleBtn__OMNBA`,
	"toggleBtnInactive": `AdminCandidates_toggleBtnInactive__6rFiN`,
	"assessmentToggleBtn": `AdminCandidates_assessmentToggleBtn__UNVXs`,
	"assessmentResumeBtn": `AdminCandidates_assessmentResumeBtn__NzB6z`,
	"codeCell": `AdminCandidates_codeCell__BUR5k`,
	"codeValue": `AdminCandidates_codeValue__mhnD6`,
	"copyBtn": `AdminCandidates_copyBtn__oeFxp`,
	"deleteModalContent": `AdminCandidates_deleteModalContent__jEBt1`,
	"deleteIcon": `AdminCandidates_deleteIcon__MiVOR`,
	"shake": `AdminCandidates_shake__dhxWZ`,
	"deleteTitle": `AdminCandidates_deleteTitle__PpBuD`,
	"deleteMessage": `AdminCandidates_deleteMessage__UL8Br`,
	"deleteWarning": `AdminCandidates_deleteWarning__xumfM`
};
export default ___CSS_LOADER_EXPORT___;
